const ResetJs = {
    'form' : {
        initializeForm : ()=>{
            window.$("#reset-password-form").validate({
                rules: {
                    password: {
                        required: true,
                        minlength: 8,
                    },

                    email: {
                        required: true,
                        email:true
                    },

                    password_confirmation: {
                        required: true,
                        minlength: 8,
                        equalTo: "#password"
                    },

                },
                messages: {
                    password_confirmation:{
                        equalTo: "Your passwords don't match!",
                        minlength: "Please enter at least 8 characters."
                    },
                },

                errorElement : 'div',
                errorPlacement: function(error, element) {
                    const placement = window.$(element).data('error red-text');
                    if (placement) {
                        window.$(placement).append(error)
                    } else {
                        error.insertAfter(element);
                    }
                }
            });
        }
    }
};

export default ResetJs;